<template>
  <div class="w-full">
    <SideBar
      :active="modal"
      :visualizar="blockActions"
      icon="note"
      size="large"
      textSucces="Enviar"
      title="NOTA AUTOMÁTICA"
      @hide="modal = false"
      @success="submitForm()"
    >
      <div slot="body" class="mx-2">
        <div
          :id="'loadingNota' + fatura.id"
          class="w-full vs-con-loading__container"
        >
          <div class="w-full">
            <VuePerfectScrollbar
              :settings="settings"
              class="scroll-cadastrar-nota"
            >
              <div class="w-full">
                <Tomador :cliente="cliente" />
                <vs-row
                  vs-align="flex-start"
                  vs-justify="center"
                  vs-type="flex"
                >
                  <vx-card card-border no-shadow>
                    <vs-row
                      vs-align="center"
                      vs-justify="center"
                      vs-type="flex"
                    >
                      <vs-col
                        vs-align="center"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="3"
                      >
                        <div class="w-full mx-2">
                          <vs-input
                            v-model="nota.rps"
                            v-validate="'required'"
                            class="w-full"
                            color="dark"
                            label="RPS"
                            name="rps"
                            type="number"
                          ></vs-input>
                          <vs-row
                            vs-align="center"
                            vs-justify="flex-start"
                            vs-w="12"
                          >
                            <span
                              v-show="errors.has('rps')"
                              class="text-danger"
                              style="font-size: 12px"
                            >
                              {{ $validators.empty }}
                            </span>
                          </vs-row>
                        </div>
                      </vs-col>
                      <vs-col
                        vs-align="center"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="3"
                      >
                        <div class="w-full mx-2">
                          <vs-input
                            v-model="nota.valor_bruto"
                            class="w-full"
                            color="dark"
                            disabled="true"
                            icon="R$"
                            icon-after="true"
                            label="Valor Bruto"
                            name="valorDoc"
                            type="text"
                          ></vs-input>
                        </div>
                      </vs-col>
                      <vs-col
                        vs-align="center"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="3"
                      >
                        <div class="w-full mx-2">
                          <vs-input
                            :key="reRenderComponents"
                            v-model="nota.valor_liquido"
                            v-validate="'required'"
                            class="w-full"
                            color="dark"
                            disabled="true"
                            icon="R$"
                            icon-after="true"
                            label="Valor Líquido"
                            name="valorDoc"
                            type="text"
                          ></vs-input>
                          <vs-row
                            vs-align="center"
                            vs-justify="flex-start"
                            vs-w="12"
                          >
                            <span
                              v-show="errors.has('valorDoc')"
                              class="text-danger"
                              style="font-size: 12px"
                            >
                              {{ $validators.empty }}
                            </span>
                          </vs-row>
                        </div>
                      </vs-col>
                      <vs-col
                        vs-align="center"
                        vs-justify="center"
                        vs-type="flex"
                        vs-w="3"
                      >
                        <div class="mx-2">
                          <vs-checkbox
                            :key="reRenderComponents"
                            v-model="nota.iss_retido"
                            class="pt-5"
                            color="success"
                            @change="descontarIss($event.type)"
                          >
                            RETER ISS
                          </vs-checkbox>
                        </div>
                      </vs-col>
                    </vs-row>
                    <vs-row
                      vs-align="flex-start"
                      vs-justify="center"
                      vs-type="flex"
                      vs-w="12"
                    >
                      <vs-col
                        vs-align="center"
                        vs-justify="center"
                        vs-type="flex"
                        vs-w="12"
                      >
                        <div class="w-full mx-2">
                          <vs-input
                            v-model="nota.link"
                            class="w-full"
                            color="dark"
                            label="Link da nota fiscal"
                            type="text"
                          ></vs-input>
                        </div>
                      </vs-col>
                    </vs-row>
                    <vs-row
                      vs-align="flex-start"
                      vs-justify="center"
                      vs-type="flex"
                      vs-w="12"
                    >
                      <vs-col
                        vs-align="center"
                        vs-justify="center"
                        vs-type="flex"
                        vs-w="12"
                      >
                        <div class="w-full px-2 my-3">
                          <vs-textarea
                            v-model="nota.obs"
                            class="m-0"
                            color="dark"
                            height="100"
                            label="Observação"
                            style="text-align: justify"
                          />
                        </div>
                      </vs-col>
                    </vs-row>
                  </vx-card>
                </vs-row>
                <vs-divider class="my-3 font-semibold">Tributações</vs-divider>
                <vs-row
                  class="my-3"
                  vs-align="flex-start"
                  vs-justify="center"
                  vs-type="flex"
                >
                  <vx-card card-border no-shadow>
                    <vs-row
                      class="mb-2"
                      vs-align="flex-start"
                      vs-justify="flex-start"
                      vs-type="flex"
                      vs-w="12"
                    >
                      <vs-col
                        class="m-0"
                        vs-align="center"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="3"
                      >
                        <vs-input
                          :key="reRenderComponents"
                          v-model="nota.valorPis"
                          v-validate="'required'"
                          :label="
                            'PIS: ' +
                            (empresa.valorPis ? empresa.valorPis : 0) +
                            '%'
                          "
                          class="mx-2"
                          color="dark"
                          icon="R$"
                          icon-after="true"
                          min="0"
                          name="pis"
                          type="text"
                          @change="descontarTributos()"
                        ></vs-input>
                      </vs-col>
                      <vs-col
                        vs-align="center"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="3"
                      >
                        <vs-input
                          :key="reRenderComponents"
                          v-model="nota.valorCofins"
                          v-validate="'required'"
                          :label="
                            'COFINS: ' +
                            (empresa.valorCofins ? empresa.valorCofins : 0) +
                            '%'
                          "
                          class="mx-2"
                          color="dark"
                          icon="R$"
                          icon-after="true"
                          min="0"
                          name="cofins"
                          type="text"
                          @change="descontarTributos()"
                        ></vs-input>
                      </vs-col>
                      <vs-col
                        vs-align="center"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="3"
                      >
                        <vs-input
                          :key="reRenderComponents"
                          v-model="nota.valorCsll"
                          v-validate="'required'"
                          label="CSLL"
                          class="mx-2"
                          color="dark"
                          icon="R$"
                          icon-after="true"
                          min="0"
                          name="csll"
                          type="text"
                          @change="descontarTributos()"
                        ></vs-input>
                      </vs-col>
                      <vs-col
                        vs-align="center"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="3"
                      >
                        <vs-input
                          :key="reRenderComponents"
                          v-model="nota.valorIr"
                          label="IR"
                          class="mx-2"
                          color="dark"
                          icon="R$"
                          icon-after="true"
                          min="0"
                          name="ir"
                          type="text"
                          @change="descontarTributos()"
                        ></vs-input>
                      </vs-col>
                      <vs-col
                        vs-align="center"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="3"
                      >
                        <vs-input
                          :key="reRenderComponents"
                          v-model="nota.valorInss"
                          :label="
                            'INSS: ' +
                            (empresa.valorInss ? empresa.valorInss : 0) +
                            '%'
                          "
                          class="mx-2"
                          color="dark"
                          icon="R$"
                          icon-after="true"
                          min="0"
                          name="inss"
                          type="text"
                          @change="descontarTributos()"
                        ></vs-input>
                      </vs-col>
                    </vs-row>
                  </vx-card>
                </vs-row>
                <vs-divider class="my-0 font-semibold"
                  >Datas de Vencimento</vs-divider
                >
                <vs-row
                  class="my-3"
                  vs-align="flex-start"
                  vs-justify="center"
                  vs-type="flex"
                >
                  <vx-card :key="reRenderComponents" card-border no-shadow>
                    <vs-row
                      class="mb-2"
                      vs-align="center"
                      vs-justify="flex-start"
                      vs-type="flex"
                      vs-w="12"
                    >
                      <vs-col
                        v-for="(data, index) in datasVencimento"
                        :key="index"
                        vs-align="center"
                        vs-justify="center"
                        vs-type="flex"
                        vs-w="4"
                      >
                        <div class="w-full mx-2">
                          <vs-input
                            v-model="datasVencimento[index].data"
                            v-validate="'required'"
                            :label="'Data Parcela N° ' + (index + 1)"
                            :name="'datas' + index"
                            color="dark"
                            type="date"
                          />
                          <vs-input
                            v-model="datasVencimento[index].valor"
                            v-validate="'required'"
                            :label="'Valor Parcela N° ' + (index + 1)"
                            :name="'valores' + index"
                            class="mt-3"
                            color="dark"
                            disabled="true"
                            type="number"
                          />
                          <vs-row
                            vs-align="center"
                            vs-justify="flex-start"
                            vs-w="12"
                          >
                            <span
                              v-show="errors.has('datas' + index)"
                              class="text-danger"
                              style="font-size: 12px"
                            >
                              {{ $validators.empty }}
                            </span>
                          </vs-row>
                        </div>
                      </vs-col>
                    </vs-row>
                  </vx-card>
                </vs-row>
                <Prestador :empresa="empresa" />
                <div v-if="detalheCalculoLiquido">
                  <vs-divider class="my-3 font-semibold"
                    >Detalhamento do cálculo (centavos)</vs-divider
                  >
                  <vx-card card-border no-shadow class="mb-4">
                    <div
                      class="text-sm"
                      style="
                        font-family: ui-monospace, monospace;
                        line-height: 1.5;
                      "
                    >
                      <p class="mb-2">
                        <strong>Valor bruto</strong>
                        → {{ $currency(detalheCalculoLiquido.brutoReais) }} =
                        <strong>{{ detalheCalculoLiquido.brutoCents }}</strong>
                        centavos
                      </p>
                      <p
                        v-for="(
                          linha, idx
                        ) in detalheCalculoLiquido.tributosLinhas"
                        :key="'tr-' + idx"
                        class="mb-1"
                      >
                        <strong>{{ linha.nome }}</strong> =
                        {{ linha.pctTexto }} →
                        <strong>{{ linha.cents }}</strong>
                        centavos ({{ $currency(linha.reais) }})
                      </p>
                      <p class="mb-2">
                        <strong>Soma PIS+COFINS+CSLL+INSS+IR</strong>
                        →
                        <strong>{{
                          detalheCalculoLiquido.somaTributosCents
                        }}</strong>
                        centavos ({{
                          $currency(detalheCalculoLiquido.somaTributosReais)
                        }})
                      </p>
                      <p class="mb-2">
                        <strong>ISS</strong>
                        <template v-if="detalheCalculoLiquido.issRetido">
                          ({{ detalheCalculoLiquido.issPctTexto }} sobre o
                          bruto, retido) → numerador =
                          {{ detalheCalculoLiquido.issNumerador }} →
                          <strong>{{
                            detalheCalculoLiquido.issCentsEquiv
                          }}</strong>
                          centavos ({{
                            $currency(detalheCalculoLiquido.issReaisEquiv)
                          }}) descontados do líquido
                        </template>
                        <template v-else>
                          — sem retenção (não desconta do líquido)
                        </template>
                      </p>
                      <vs-divider class="my-2" />
                      <p class="mb-1">
                        <strong>Fórmula do líquido (igual à NFS-e)</strong>
                      </p>
                      <p
                        class="mb-1"
                        style="white-space: pre-wrap; line-height: 1.4"
                      >
                        iss_centavos = arredondar((bruto_centavos × iss_bp) /
                        {{ detalheCalculoLiquido.denom }}) =
                        {{ detalheCalculoLiquido.issCentsEquiv }}<br />
                        líquido_centavos = bruto_centavos −
                        soma_tributos_centavos − iss_centavos<br />
                        = {{ detalheCalculoLiquido.brutoCents }} −
                        {{ detalheCalculoLiquido.somaTributosCents }} −
                        {{ detalheCalculoLiquido.issCentsEquiv }} =
                        <strong>{{
                          detalheCalculoLiquido.liquidoCentsFormula
                        }}</strong>
                        centavos
                      </p>
                      <p class="mb-0">
                        <strong>Valor líquido final</strong>
                        →
                        {{ $currency(detalheCalculoLiquido.liquidoReais) }} ({{
                          detalheCalculoLiquido.liquidoCentsFormula
                        }}
                        centavos)
                      </p>
                      <p
                        v-if="!detalheCalculoLiquido.formulaIgualNota"
                        class="text-warning mt-2 mb-0"
                        style="font-size: 12px"
                      >
                        Atenção: o valor exibido no campo líquido difere em 1
                        centavo do fechamento da fórmula (arredondamento /
                        exibição).
                      </p>
                    </div>
                  </vx-card>
                </div>
              </div>
            </VuePerfectScrollbar>
          </div>
        </div>
      </div>
    </SideBar>
    <component
      v-bind:is="modalVerErrosNota"
      :key="reRenderModalVerErrosNota"
      :json="erroJson"
      :nota="null"
      titulo="Ver Erros Envio de RPS"
    />
  </div>
</template>
<script>
import components from "@/components/default/exports.js";
import Tomador from "./tomador";
import Prestador from "./prestador";
import verErros from "./verErros";
import { roundHalfEvenDivision } from "./roundHalfEven.js";

export default {
  props: {
    fatura: null,
    contrato: {},
  },
  data() {
    return {
      denom: 10000,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      cliente: {},
      empresa: {},
      enderecoFaturamento: {},
      nota: {
        obs: null,
        rps: null,
        protocolo: null,
        id_forma_pagamento: null,
        dataHoje: this.$formartData.dataHoje(),
        valor_bruto: null,
        valor_liquido: null,
        iss_retido: false,
        link: "",
        numero: "",
        id_colaborador: null,
        id_faturamento: null,
        id_contrato: null,
        id_empresa: null,
        data_emissao: null,
        valorPis: 0,
        valorCofins: 0,
        valorCsll: 0,
        valorIr: 0,
        valorInss: 0,
      },
      jsonNota: {},
      datasVencimento: [],
      modal: false,
      reRenderComponents: 0,
      blockActions: false,
      parametros: {},
      modalVerErrosNota: "",
      reRenderModalVerErrosNota: 0,
      erroJson: {},
      textoPorcentagensServico: "",
    };
  },
  computed: {
    detalheCalculoLiquido() {
      const vb = this.nota && this.nota.valor_bruto;
      if (
        vb === undefined ||
        vb === null ||
        (typeof vb === "string" && String(vb).trim() === "")
      ) {
        return null;
      }
      const denom = this.denom;
      const brutoCents = this.toCents(this.nota.valor_bruto);
      const issBp = this.nota.iss_retido
        ? this.toBasisPoints(this.parametros.iss || 0)
        : 0;
      const issNumerador = brutoCents * issBp;
      const issCentsEquiv =
        issBp > 0 && this.nota.iss_retido
          ? roundHalfEvenDivision(issNumerador, denom)
          : 0;

      const tributosLinhas = [
        {
          nome: "PIS",
          pctTexto: `${this.aliquotaTexto(this.empresa.valorPis)}%`,
          cents: this.toCents(this.nota.valorPis),
          reais: this.fromCents(this.toCents(this.nota.valorPis)),
        },
        {
          nome: "COFINS",
          pctTexto: `${this.aliquotaTexto(this.empresa.valorCofins)}%`,
          cents: this.toCents(this.nota.valorCofins),
          reais: this.fromCents(this.toCents(this.nota.valorCofins)),
        },
        {
          nome: "CSLL",
          pctTexto: `${this.aliquotaTexto(this.empresa.valorCsll)}%`,
          cents: this.toCents(this.nota.valorCsll),
          reais: this.fromCents(this.toCents(this.nota.valorCsll)),
        },
        {
          nome: "INSS",
          pctTexto: `${this.aliquotaTexto(this.empresa.valorInss)}%`,
          cents: this.toCents(this.nota.valorInss),
          reais: this.fromCents(this.toCents(this.nota.valorInss)),
        },
        {
          nome: "IR (retenção)",
          pctTexto: "1% (fixo no cálculo automático)",
          cents: this.toCents(this.nota.valorIr),
          reais: this.fromCents(this.toCents(this.nota.valorIr)),
        },
      ];

      const somaTributosCents = tributosLinhas.reduce(
        (acc, row) => acc + row.cents,
        0
      );
      const somaTributosReais = this.fromCents(somaTributosCents);

      const liquidoCentsFormula =
        brutoCents - somaTributosCents - issCentsEquiv;
      const liquidoReais = this.fromCents(liquidoCentsFormula);
      const liquidoCentsNota = this.toCents(this.nota.valor_liquido);

      const issPctRaw = this.parametros.iss;
      const issPctTexto =
        issPctRaw === undefined || issPctRaw === null || issPctRaw === ""
          ? "—"
          : `${this.aliquotaTexto(issPctRaw)}%`;

      return {
        denom,
        brutoCents,
        brutoReais: this.nota.valor_bruto,
        tributosLinhas,
        somaTributosCents,
        somaTributosReais,
        issRetido: !!this.nota.iss_retido,
        issPctTexto,
        issBp,
        issNumerador,
        issCentsEquiv,
        issReaisEquiv: this.fromCents(issCentsEquiv),
        liquidoCentsFormula,
        liquidoReais,
        formulaIgualNota: liquidoCentsFormula === liquidoCentsNota,
      };
    },
  },
  methods: {
    //FUNÇÕES INICIAL
    async openModal() {
      await this.$vs.loading({
        container: "#loadingNota" + this.fatura.id,
        scale: 0.6,
      });
      this.blockActions = true;
      this.modal = await true;
      try {
        this.parametros = await this.$parametros.get();
        await this.getNumeroRPS();
        await this.getEmpresa();
        await this.getCliente();
        await this.getEnderecoFaturamento();
        await this.setCamposNota();
        this.recalcularTributosCents();
        await this.descontarIss("change");
        await this.descontarTributos();
        await this.setDatasVencimento();
        await this.montarObs();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        this.blockActions = false;
        await this.$vs.loading.close(
          "#loadingNota" + this.fatura.id + " > .con-vs-loading"
        );
      }
    },

    //FUNÇÕES SET PARA OS VALORES DA NOTA
    //SETAR OS CAMPOS NECESSARIOS PARA CADASTRAR A NOTA APÓS O ENVIO DO RPS
    async setCamposNota() {
      const faturaCents = this.toCents(this.fatura.valor);
      const descontoPct = Number(this.contrato.desconto || 0) / 100;
      const valorBaseCents = Math.round(faturaCents * (1 - descontoPct));
      const valorBase = this.fromCents(valorBaseCents);

      this.nota.iss_retido = this.cliente.iss_retido;
      this.nota.data_emissao = this.$formartData.dataFiltro();
      this.nota.valor_liquido = valorBase;
      this.nota.valor_bruto = valorBase;
      this.nota.link = ``;
      this.nota.numero = "";
      this.nota.id_colaborador = localStorage.getItem("id");
      this.nota.id_faturamento = this.fatura.id;
      this.nota.id_contrato = this.contrato.id;
      this.nota.id_empresa = this.contrato.id_empresa;
    },

    //SETAR AS DATAS DE VENCIMENTO DAS PARCELAS, DEPENDENDO DO TIPO DO CONTRATO
    //SETAR AS DATAS DE VENCIMENTO DAS PARCELAS, DEPENDENDO DO TIPO DO CONTRATO
    async setDatasVencimento() {
      this.datasVencimento = [];
      let dataVencimento;

      const hasEntrada = this.contrato.entrada > 0;

      if (hasEntrada) {
        dataVencimento = await this.$formartData.formatar(
          this.contrato.data_entrada,
          1
        );
      } else {
        dataVencimento = await this.$formartData.formatar(
          this.$formartData.dataHoje(),
          1
        );
        dataVencimento = await this.$formartData.somarDias(
          dataVencimento,
          this.contrato.intervalo_parcela
        );
      }

      const intervaloParcela = this.contrato.intervalo_parcela;

      if ([1, 2, 3, 6].includes(this.contrato.id_tipo_faturamento)) {
        if (hasEntrada) {
          let dataFormatada = await this.$formartData.formatar(
            dataVencimento,
            1
          );
          this.datasVencimento.push({
            data: dataFormatada,
            valor: this.contrato.entrada,
          });
          dataVencimento = await this.$formartData.somarDias(
            dataVencimento,
            intervaloParcela
          );
        }
        for (let i = 1; i <= this.contrato.parcelas; i++) {
          let dataFormatada = await this.$formartData.formatar(
            dataVencimento,
            1
          );
          this.datasVencimento.push({ data: dataFormatada, valor: 0 });
          dataVencimento = await this.$formartData.somarDias(
            dataVencimento,
            intervaloParcela
          );
        }
      } else {
        let dataFormatada = await this.$formartData.formatar(dataVencimento, 1);
        this.datasVencimento.push({ data: dataFormatada, valor: 0 });
      }

      let cont = 1;
      for (let data of this.datasVencimento) {
        if (cont === 1 && hasEntrada) {
          cont++;
          continue;
        } else {
          let valorConta;

          if (
            this.contrato.entrada > 0 &&
            this.contrato.id_forma_pagamento_entrada > 0
          ) {
            valorConta = this.roundCurrency(
              (this.nota.valor_liquido - this.contrato.entrada) /
                (this.datasVencimento.length - 1)
            );

            if (cont === this.datasVencimento.length) {
              valorConta = this.roundCurrency(
                valorConta -
                  (valorConta * (this.datasVencimento.length - 1) -
                    (this.nota.valor_liquido - this.contrato.entrada))
              );
            }
          } else {
            valorConta = this.roundCurrency(
              this.nota.valor_liquido / this.datasVencimento.length
            );

            if (cont === this.datasVencimento.length) {
              valorConta = this.roundCurrency(
                valorConta -
                  (valorConta * this.datasVencimento.length -
                    this.nota.valor_liquido)
              );
            }
          }

          data.valor = valorConta;
        }

        cont++;
      }

      this.reRenderComponents += 1;
    },

    //SETAR O JSON DA NOTA QUE É ENVIADO PARA A API PARA SER PROCESSADO
    async setJsonNota() {
      // Formatar data de competência para YYYY-MM-DD
      let dCompet = this.nota.data_emissao; // Já vem do dataFiltro()

      this.jsonNota.id_contrato = this.contrato.id;

      // Construção do JSON no formato DPS (Padrão Nacional idealizado para o fiscal-core)
      this.jsonNota.json = {
        identificacao: {
          nDPS: this.nota.rps,
          serie: (this.empresa && this.empresa.serie_dps) ? `${this.empresa.serie_dps}` : "1",
          tpAmb: 2, // 2 - Homologação (Fixo por enquanto conforme instrução)
          dCompet: dCompet,
          // passphrase nao vem mais do frontend (issue #462) - o backend injeta
          // a partir de empresas.senha (Encryption), pelo CNPJ do prestador.
        },
        prest: {
          cnpj: await this.$removerMascara.remove(`${this.empresa.cnpj}`),
          ccm: await this.$removerMascara.remove(
            `${this.empresa.inscricao_municipal}`
          ),
          opSimpNac: (function(opt) {
            if (opt == 2) return "2";
            if (opt == 1 || opt == 3) return "3";
            return "1";
          })(this.empresa.optante_simples_nacional),
          regEspTrib: (this.empresa && this.empresa.regime_especial_tributacao != null)
            ? `${this.empresa.regime_especial_tributacao}`
            : "0",
          regApTribSN: (this.empresa && (this.empresa.optante_simples_nacional == 1 || this.empresa.optante_simples_nacional == 3) && this.empresa.regime_apuracao_simples_nacional)
            ? `${this.empresa.regime_apuracao_simples_nacional}`
            : undefined,
        },
        serv: {
          cTribNac: (this.empresa && this.empresa.codigo_tributacao_nacional)
            ? await this.$removerMascara.remove(`${this.empresa.codigo_tributacao_nacional}`)
            : "071301",
          cTribMun: (this.empresa && this.empresa.codigo_tributacao_municipal)
            ? `${this.empresa.codigo_tributacao_municipal}`.trim()
            : null,
          xDescServ: (this.empresa && this.empresa.texto_beneficio_fiscal)
            ? (this.nota.obs ? `${this.nota.obs}\n${this.empresa.texto_beneficio_fiscal}` : `${this.empresa.texto_beneficio_fiscal}`)
            : this.nota.obs,
          cNBS: (this.empresa && this.empresa.codigo_nbs)
            ? await this.$removerMascara.remove(`${this.empresa.codigo_nbs}`)
            : "118032100",
        },
        toma: {
          doc: await this.$removerMascara.remove(`${this.cliente.cpf_cnpj}`),
          tipoDoc: `${this.cliente.tipo_pessoa}`, // 1-CPF, 2-CNPJ (Assumindo que o front já usa 2 para PJ)
          xNome: this.cliente.razao_social || this.cliente.nome_fantasia,
          email: this.cliente.email || "financeiro@exemplo.com", // Fallback para evitar erro se obrigatório
          fone: await this.$removerMascara.remove(`${this.cliente.telefone}`),
          im: await this.$removerMascara.remove(
            `${this.cliente.inscricao_municipal}`
          ),
          end: {
            xLgr: this.enderecoFaturamento.logradouro
              ? this.enderecoFaturamento.logradouro.substring(0, 100)
              : "",
            nro: this.enderecoFaturamento.numero || "S/N",
            xBairro: this.enderecoFaturamento.nomeBairro || "",
            cMun: this.enderecoFaturamento.codigo_municipio || "", // Vazio se nao resolvido ainda — o backend tenta resolver via IBGE (CEP/nome do municipio) antes de enviar
            uf: this.enderecoFaturamento.uf || "",
            cep: await this.$removerMascara.remove(
              `${this.enderecoFaturamento.cep}`
            ),
          },
        },
        valores: {
          vServ: parseFloat(this.nota.valor_bruto),
          aliq: parseFloat(this.parametros.iss),
          issRetido: !!this.nota.iss_retido,
          vPis: 0,
          vCofins: 0,
          vInss: parseFloat(this.nota.valorInss || 0),
          vIr: parseFloat(this.nota.valorIr || 0),
          vCsll:
            parseFloat(this.nota.valorCsll || 0) +
            parseFloat(this.nota.valorPis || 0) +
            parseFloat(this.nota.valorCofins || 0),
          vTotTribFed: (this.parametros && this.parametros.ibpt_federal)
            ? parseFloat(this.parametros.ibpt_federal)
            : 13.45,
          vTotTribEst: (this.parametros && this.parametros.ibpt_estadual)
            ? parseFloat(this.parametros.ibpt_estadual)
            : 0.0,
          vTotTribMun: (this.parametros && this.parametros.ibpt_municipal)
            ? parseFloat(this.parametros.ibpt_municipal)
            : 4.98,
        },
      };
    },

    validarParametrosFiscaisEmpresa() {
      if (!this.empresa) {
        this.$vs.notify({
          title: "Empresa não encontrada",
          text: "Não foi possível carregar os dados da empresa prestadora.",
          color: "danger"
        });
        return false;
      }
      const isMeEpp = this.empresa.optante_simples_nacional == 1 || this.empresa.optante_simples_nacional == 3;
      if (isMeEpp && !this.empresa.regime_apuracao_simples_nacional) {
        this.$vs.notify({
          title: "Regime de Apuração do Simples Nacional obrigatório",
          text: "A empresa prestadora está cadastrada como Optante pelo Simples Nacional (ME/EPP), mas o Regime de Apuração dos Tributos (regApTribSN) não foi informado. Acesse Configurações > Empresa e selecione o Regime de Apuração antes de emitir.",
          color: "danger",
          time: 8000
        });
        return false;
      }
      return true;
    },

    //FUNÇÕES PARA SALVAR/ALTERAR VALORES
    //VALIDAR OS CAMPOS QUE PRECISAM SER PREENCHIDOS
    async submitForm() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          if (!this.validarParametrosFiscaisEmpresa()) {
            return;
          }
          this.cadastrarNota();
        } else {
          this.error = true;
          this.$vs.notify(this.$notify.Empty);
        }
      });
    },

    //CADASTRO DA NOTA, BOLETO SE TIVER, ENVIO DO RPS PARA A API
    async cadastrarNota() {
      await this.$vs.loading({
        container: "#loadingNota" + this.fatura.id,
        scale: 0.6,
      });
      this.blockActions = true;
      try {
        await this.setJsonNota();
        await this.removeValoresTributacao();
        await this.$http.post("redirectSalvarNota", {
          nota: this.nota,
          contrato: this.contrato,
          datas: this.datasVencimento,
          json: this.jsonNota,
          tipo: 1,
        });
        this.$vs.notify({
          title: "RPS enviado com sucesso!",
          text: "Consulte o RPS nas opções da nota cadastrada!",
          color: "success",
        });
        await this.$emit("update");
        this.modal = await false;
      } catch (err) {
        this.modal = await false;
        if (err.response != undefined) {
          this.$vs.notify({
            title: "Erros no envio do RPS!",
            text: "Verifique os erros e tente novamente!",
            color: "danger",
          });
          this.erroJson = err.response.data;
          this.modalVerErrosNota = "verErros";
          this.reRenderModalVerErrosNota += await 1;
        } else {
          const error = this.$httpErrors(err);
          this.$vs.notify(error);
          if (error.code == 401) {
            await window.localStorage.clear();
            await this.$router.push("/");
          }
        }
      } finally {
        this.blockActions = false;
        await this.$vs.loading.close(
          "#loadingNota" + this.fatura.id + " > .con-vs-loading"
        );
      }
    },

    //DESCONTO DO ISS
    async descontarIss(evento) {
      if (evento !== "change") return;

      this.recalcularValorLiquido();

      await this.setDatasVencimento();
      await this.montarObs();
      this.reRenderComponents += 1;
    },

    async descontarTributos() {
      this.nota.valorCofins = this.nota.valorCofins || 0;
      this.nota.valorCsll = this.nota.valorCsll || 0;
      this.nota.valorIr = this.nota.valorIr || 0;
      this.nota.valorPis = this.nota.valorPis || 0;
      this.nota.valorInss = this.nota.valorInss || 0;

      this.recalcularValorLiquido();

      await this.setDatasVencimento();
      await this.montarObs();
      this.reRenderComponents += 1;
    },

    async removeValoresTributacao() {
      delete this.nota.valorCofins;
      delete this.nota.valorCsll;
      delete this.nota.valorInss;
      delete this.nota.valorIr;
      delete this.nota.valorPis;
    },

    //GET VALORES PARA A MONTAGEM DO JSON E DA NOTA
    async getEnderecoFaturamento() {
      try {
        this.enderecoFaturamento = await this.$http.get(
          "getEnderecoFaturamento/" + this.cliente.id
        );
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },

    async getCliente() {
      try {
        this.cliente = await this.$http.get(
          "cliente/" + this.contrato.id_cliente
        );
        this.cliente.nome_fantasia = this.cliente.nome_fantasia
          ? this.cliente.nome_fantasia.replace("&", "")
          : "";
        this.cliente.razao_social = this.cliente.razao_social
          ? this.cliente.razao_social.replace("&", "")
          : "";
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },

    async getEmpresa() {
      try {
        this.empresa = await this.$http.get(
          `empresa/` + this.contrato.id_empresa
        );
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },

    async montarObs() {
      let discriminacao = `${this.contrato.controle} com ${
        this.contrato.garantia
      } meses de garantia. CONTRATO ${this.contrato.id}. FATURA ${
        this.fatura.parcela
      }. ${this.contrato.forma_pagamento.toUpperCase()}`;
      let parcelaTexto = "";
      for (let data of this.datasVencimento) {
        parcelaTexto +=
          (await this.$formartData.formatar(new Date(data.data))) +
          ": " +
          this.$currency(data.valor) +
          ". ";
      }
      this.nota.obs = `${discriminacao}. PARCELAS: ${parcelaTexto} TRIBUTOS APROXIMADOS de ${this.roundCurrency(
        this.nota.valor_bruto * (17 / 100)
      )}. ${this.textoPorcentagensServico}`;

      if (this.cliente.tipo_pessoa == 2 && this.empresa.texto_beneficio_fiscal) {
        this.nota.obs += `\n\n${this.empresa.texto_beneficio_fiscal}`;
      }
    },

    async getNumeroRPS() {
      try {
        this.nota.rps = await this.$http.post("getNumeroRPS", {
          id_empresa: this.contrato.id_empresa,
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },

    roundCurrency(valor) {
      return Math.round((valor + Number.EPSILON) * 100) / 100;
    },

    toCents(value) {
      if (value === null || value === undefined || value === "") {
        return 0;
      }
      const parsedValue = Number(String(value).trim().replace(",", "."));
      if (!Number.isFinite(parsedValue)) {
        return 0;
      }
      return Math.round((parsedValue + Number.EPSILON) * 100);
    },

    fromCents(cents) {
      const parsedValue = Number(cents || 0) / 100;
      return parseFloat(parsedValue.toFixed(2));
    },

    toBasisPoints(rate) {
      const parsedRate = Number(rate);
      if (!Number.isFinite(parsedRate) || parsedRate <= 0) {
        return 0;
      }

      const percent = parsedRate < 1 ? parsedRate * 100 : parsedRate;
      return Math.round(percent * 100);
    },

    /** Ex.: parâmetro 0,05 → "5" para rótulo; 5 → "5". */
    aliquotaTexto(raw) {
      const n = Number(raw);
      if (!Number.isFinite(n) || n < 0) {
        return "0";
      }
      if (n === 0) {
        return "0";
      }
      const pct = n > 0 && n < 1 ? n * 100 : n;
      return String(pct).replace(".", ",");
    },

    sumTributosCentsFromInputs() {
      return (
        this.toCents(this.nota.valorPis || 0) +
        this.toCents(this.nota.valorCofins || 0) +
        this.toCents(this.nota.valorCsll || 0) +
        this.toCents(this.nota.valorInss || 0) +
        this.toCents(this.nota.valorIr || 0)
      );
    },

    aplicaTributosEmpresa() {
      return (
        this.cliente &&
        this.empresa &&
        this.cliente.tipo_pessoa == 2 &&
        this.empresa.isenta_imposto == 0
      );
    },

    recalcularTributosCents() {
      const brutoCents = this.toCents(this.nota.valor_bruto);

      if (!this.aplicaTributosEmpresa()) {
        this.nota.valorPis = 0;
        this.nota.valorCofins = 0;
        this.nota.valorCsll = 0;
        this.nota.valorInss = 0;
        this.nota.valorIr = 0;
        this.textoPorcentagensServico = "";
        return 0;
      }

      const pisBp = this.toBasisPoints(this.empresa.valorPis || 0);
      const cofinsBp = this.toBasisPoints(this.empresa.valorCofins || 0);
      const csllBp = this.toBasisPoints(this.empresa.valorCsll || 0);
      const inssBp = this.toBasisPoints(this.empresa.valorInss || 0);
      const irBp = this.toBasisPoints(1);

      const pisNum = brutoCents * pisBp;
      const cofinsNum = brutoCents * cofinsBp;
      const csllNum = brutoCents * csllBp;
      const inssNum = brutoCents * inssBp;
      const irNum = brutoCents * irBp;

      const pisCofinsCsllNum = pisNum + cofinsNum + csllNum;
      const pisCofinsCsllDispensa = pisCofinsCsllNum <= 1000 * this.denom;
      const inssDispensa = inssNum <= 1000 * this.denom;
      const irDispensa = irNum <= 1000 * this.denom;

      const roundCents = (num) => roundHalfEvenDivision(num, this.denom);
      const pisCents = pisCofinsCsllDispensa ? 0 : roundCents(pisNum);
      const cofinsCents = pisCofinsCsllDispensa ? 0 : roundCents(cofinsNum);
      const csllCents = pisCofinsCsllDispensa ? 0 : roundCents(csllNum);
      const inssCents = inssDispensa ? 0 : roundCents(inssNum);
      const irCents = irDispensa ? 0 : roundCents(irNum);

      this.nota.valorPis = this.fromCents(pisCents);
      this.nota.valorCofins = this.fromCents(cofinsCents);
      this.nota.valorCsll = this.fromCents(csllCents);
      this.nota.valorInss = this.fromCents(inssCents);
      this.nota.valorIr = this.fromCents(irCents);

      const somaPisCsllCofins = this.fromCents(
        pisCents + cofinsCents + csllCents
      );
      this.textoPorcentagensServico =
        somaPisCsllCofins <= 10
          ? `Para PIS/COFINS/CSLL \nÉ dispensada a retenção de igual ou inferior a R$ 10,00 exceto no DARF eletrônico emitido por meio do SIAFI (Lei nº 10.833/2003, art. 31 §3º); \nPara IR \nLEI Nº 9.430, DE 27 DE DEZEMBRO DE 1996; Dispensa de Retenção de Imposto de Renda; Art. 67. Fica dispensada a retenção de imposto de renda, de valor igual ou inferior a R$ 10,00 (dez reais);`
          : "";

      return pisCents + cofinsCents + csllCents + inssCents + irCents;
    },

    recalcularValorLiquido() {
      const brutoCents = this.toCents(this.nota.valor_bruto);
      const issBp = this.nota.iss_retido
        ? this.toBasisPoints(this.parametros.iss || 0)
        : 0;
      // Arredonda o ISS retido a 2 casas decimais (centavos) ANTES de
      // subtrair do bruto, com ROUND_HALF_EVEN (bancario), igual ao Sistema
      // Nacional NFS-e e ao FiscalCalculationService do backend (ticket
      // #274 / issue #346/#260) - evita a divergência de 1 centavo quando
      // bruto x aliquota cai em ",xx5".
      const issCents =
        this.nota.iss_retido && issBp > 0
          ? roundHalfEvenDivision(brutoCents * issBp, this.denom)
          : 0;
      const tributosCents = this.sumTributosCentsFromInputs() + issCents;
      let liquidoCents = brutoCents - tributosCents;
      if (liquidoCents < 0) {
        liquidoCents = 0;
      }
      this.nota.valor_liquido = this.fromCents(liquidoCents);
    },
  },
  async mounted() {
    await this.openModal();
  },
  components: {
    ...components,
    Tomador,
    verErros,
    Prestador,
  },
};
</script>
<style lang="scss">
.scroll-cadastrar-nota {
  height: 80vh !important;
}
</style>
